<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Config.scss";
</style>
<template>
  <div>
    <div class="vx-row w-full">
        <vs-button :to="`/circuitos`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-row w-full">
      <div class="w-full p-1">
        <vx-card>
          <feather-icon v-if="!edit && response.length == 0"  @click="requestPassword()" icon="TrashIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>
          <feather-icon v-if="!edit"  @click="edit = true" icon="EditIcon" svgClasses="h-5 w-5 text-grey-ligth" class="float-right cursor-pointer hover:text-primary"/>
          <feather-icon v-if="edit" @click="edit = false" icon="XIcon" svgClasses="h-5 w-5 text-grey-ligth mx-2" class="float-right cursor-pointer hover:text-primary"/>
          <feather-icon v-if="edit && valid" @click="update()" icon="SaveIcon" svgClasses="h-5 w-5 text-grey-ligth mx-2" class="float-right cursor-pointer hover:text-primary"/> 
          <div class="text-center w-full text-lg font-bold py-4">{{$t('Labels.Circuit')}}</div>
          <div class="vx-col w-full sm:w-1/2 sm:inline-block">
            <div class="text-xs text-center mb-1">{{$t('Labels.Name')}}</div>
            <div v-if="!edit" class="font-bold text-center" >{{name}}</div>
            <vs-input v-else class="w-full" :placeholder="$t('Labels.Name')" v-model="circuit.name"/>
          </div>
          <div class="vx-col w-full sm:w-1/2 sm:inline-block">
            <div class="text-xs text-center mb-1">{{$t('Labels.Color')}}</div>
            <div class="text-center">
              <div class="w-8 h-8 inline-block rounded-sm align-middle" :style="{ 'background-color': color }"></div>
              <div v-if="!edit" class="ml-2 inline-block align-middle">{{color || 'N/A'}}</div>
              <vs-input v-else class="inline-block ml-2 w-auto" v-model="circuit.color" type="color"/>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="text-center my-2 text-2xl">{{$t('Labels.Alerts')}}</div>
    <div class="w-full p-1">
      <vx-card>
        <div class="text-danger text-center">{{$t('Messages.AlertsCircuit')}}</div>
        <div class="container-alerts">
          <minMaxItem 
            :title="$t('Labels.Current')" 
            :min="maxMin != null ? maxMin.electric_current_min : 0" 
            :max="maxMin != null ? maxMin.electric_current_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid"
            paramMin="electric_current_min" 
            paramMax="electric_current_max" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="10"
            ></minMaxItem>
          
          <minMaxItem 
            :title="$t('Labels.Voltage')" 
            :min="maxMin != null ? maxMin.electric_voltage_min : 0" 
            :max="maxMin != null ? maxMin.electric_voltage_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid"
            :paramMin="`electric_voltage_min`" 
            :paramMax="`electric_voltage_max`" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="1000"
            ></minMaxItem>

          <minMaxItem 
            :title="$t('Labels.ActivePower')" 
            :min="maxMin != null ? maxMin.active_power_min : 0" 
            :max="maxMin != null ? maxMin.active_power_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid"
            paramMin="active_power_min" 
            paramMax="active_power_max" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="1000"
            ></minMaxItem>

          <minMaxItem 
            :title="$t('Labels.ReactivePower')" 
            :min="maxMin != null ? maxMin.reactive_power_min : 0" 
            :max="maxMin != null ? maxMin.reactive_power_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid"
            paramMin="reactive_power_min" 
            paramMax="reactive_power_max" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="1000"
            ></minMaxItem>

          <minMaxItem 
            :title="$t('Labels.ApparentPower')" 
            :min="maxMin != null ? maxMin.apparent_power_min : 0" 
            :max="maxMin != null ? maxMin.apparent_power_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid" 
            paramMin="apparent_power_min" 
            paramMax="apparent_power_max" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="1000"
            ></minMaxItem>

          <minMaxItem 
            :title="$t('Labels.PowerFactor')" 
            :min="maxMin != null ? maxMin.factor_power_min : 0" 
            :max="maxMin != null ? maxMin.factor_power_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid" 
            paramMin="factor_power_min" 
            paramMax="factor_power_max" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="1"
            :step="0.1"
            ></minMaxItem>

          <minMaxItem 
            :title="$t('Labels.ActiveEnergy')" 
            :min="maxMin != null ? maxMin.active_energy_min : 0" 
            :max="maxMin != null ? maxMin.active_energy_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid"
            paramMin="active_energy_min" 
            paramMax="active_energy_max" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="4294967295"
            ></minMaxItem>

          <minMaxItem 
            :title="$t('Labels.ReactiveEnergy')" 
            :min="maxMin != null ? maxMin.reactive_energy_min : 0" 
            :max="maxMin != null ? maxMin.reactive_energy_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid"
            paramMin="reactive_energy_min" 
            paramMax="reactive_energy_max" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="4294967295"
            ></minMaxItem>

          <minMaxItem 
            :title="$t('Labels.Frequency')" 
            :min="maxMin != null ? maxMin.frequency_min : 0" 
            :max="maxMin != null ? maxMin.frequency_max : 0" 
            unit="" 
            :url="`luminaires_devices/alerts_ranges/circuit`" 
            :uuid="uuid"
            paramMin="frequency_min" 
            paramMax="frequency_max" 
            type="PUT"
            :rangeMin="0"
            :rangeMax="100"
            ></minMaxItem>
        </div>
      </vx-card>
    </div>
    <div class="vx-row mt-4 p-1 float-right">
        <vs-button :to="`/circuitos/${uuid}/assign`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Assign')}}</vs-button>
    </div>
    <div class="vx-row w-full">
      <div class="w-full p-1">
        <div class="text-center my-2 text-2xl">{{$t('Labels.Luminaries')}}</div>
        <vx-card>
          <vs-table  v-if="response.length > 0" :data="response" @selected="goToDetail">
            <template slot="thead">
              <vs-th >
                {{$t('Labels.Status')}}
              </vs-th>
              <vs-th >
                {{$t('Labels.Name')}}
              </vs-th>
              <vs-th>
                {{$t('Labels.Serie')}}
              </vs-th>
              <vs-th>
                {{$t('Labels.LastSeen')}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="item" :key="index" @click="goToDetail(item.id)" v-for="(item, index) in data" :class="{'inactive': !item.updatedAt }">
                <vs-td>
                  <div class="text-left my-2">
                    <iconLight class="align-middle" width="50" height="50" iconColor="#ffbd59" :level="parseInt(item.dimming) * 100 / 255" />
                    <span class="font-bold align-middle">{{Math.ceil(parseInt(item.dimming) * 100 / 255)}} %</span>
                  </div>
                </vs-td>
                <vs-td :data="item.name">
                  {{item.name}}
                </vs-td>
                <vs-td :data="item.serie">
                  {{item.serie}}
                </vs-td>
                <vs-td :data="item.updatedAt">
                  <span>{{item.updatedAt.length > 0 ? relativeTimeConvert(item.updatedAt) : $t('Labels.Inactive')}}</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-pagination class="mt-5" v-if="response.length > 0" :max="3" :total="totalPages" v-model="currentx"></vs-pagination>
          <div class="text-center" v-else>{{$t('Messages.NotAssignedLuminaries')}}</div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import iconLight from '@/components/icons/iconLight'
import {globalPassActions} from '@/globalPass'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'

export default {
  components: {
    iconLight,
    minMaxItem
  },
  data () {
    return {
      uuid: this.$route.params.uuid,
      circuit:{
        name: '',
        color: ''
      },
      edit: false,
      response: [],
      filters:{
        limit: 20,
        offset: 0,
        byColumn: 'updatedAt',
        byOrder: 'ASC',
        luminary_circuit_uuid: this.$route.params.uuid
      },
      currentx: 1,
      totalPages: 0,
      name: '',
      color: '',
      maxMin: null,
      ban: false
    }
  },
  methods: {
    async getCircuit () {
      const params = {
        url: `luminaires_circuits/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.circuit = response.data.data
        this.name = this.circuit.name
        this.color = this.circuit.color
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async update () {
      const params = {
        url: `luminaires_circuits/${this.uuid}`,
        method: 'PUT',
        params: this.circuit
      }
      await request(params).then(() => {
        this.name = this.circuit.name
        this.color = this.circuit.color
        this.edit = false
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getResponse () {
      const params = {
        url: 'luminaires_devices',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => {
        this.setPages(response.data.data.count)
        this.response = response.data.data.rows
      }).catch(() => {
        this.response = []
        this.totalPages = 0
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    requestPassword () {
      this.ban = true
      globalPassActions.show()
    },
    async doDelete () {
      const params = {
        url: `luminaires_circuits/${this.uuid}`,
        method: 'DELETE',
        params: {}
      }
      await request(params).then(() => {
        window.location.href = '/circuitos'
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    }, 
    goToDetail (tr) {
      if (!empty(tr.uuid)) window.location.href = `/luminarias/${tr.uuid}`
    },   
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    async getMaxiMin () {
      this.$vs.loading()
      const params = {
        url: `luminaires_circuits/${this.uuid}/maximum_minimum`,
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.maxMin = response.data.data
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getCircuit()
    this.getResponse()
    this.getMaxiMin()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible === false && this.ban === true) {
        this.ban = false
        this.doDelete()
      }
    }
  },
  computed: {
    isVisiblePassword () {
      return globalPassActions.getStatus()
    },
    valid () {
      if (!empty(this.circuit.name) && !empty(this.circuit.color)) return true
      else return false
    } 
  }
}
</script>